<ng-container *ngIf="point; else noLocation">
  <button class="btn btn-link" (click)="open(locationModal, $event)">View map</button>
  <div class="coordinates">Lat: {{ point.coordinates[0] }}</div>
  <div class="coordinates">Lon: {{ point.coordinates[1] }}</div>
</ng-container>

<ng-template #noLocation> No location data </ng-template>

<ng-template #locationModal let-modal>
  <div class="modal-header">
    <h4 class="h4 modal-title" id="modal-basic-title">View Location</h4>
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <agm-map
      [latitude]="point.coordinates[0]"
      [longitude]="point.coordinates[1]"
      [mapTypeControl]="'true'"
      [zoom]="16"
      (mapReady)="logGoogleMapsUsage()"
    >
      <agm-marker [latitude]="point.coordinates[0]" [longitude]="point.coordinates[1]"></agm-marker>
    </agm-map>
  </div>
</ng-template>
